import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numfiler'
})
export class NumfilerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      //获取到的值 value


      //处理数据    


      //返回数据  return  xxx;
    return null;
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/numfiler.pipe.ts